export type SupportUserApiDto = {
  id: string
  displayName: string
}

export type SupportUser = SupportUserApiDto

export const toSupportUser = (dto: SupportUserApiDto): SupportUser => ({
  ...dto,
})
